import Head from 'next/head'
import { useRouter } from 'next/router'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { siteConfig } from '@/constants/site'

export const Seo: FC<SeoProps> = ({
    title,
    description = siteConfig.description,
    ogImage = siteConfig.ogImage
}): ReactNode => {
    const { pathname } = useRouter()
    const pageTitle = title ? `${title} - ${siteConfig.name}` : siteConfig.name
    const pageUrl = `${siteConfig.url}${pathname === '/' ? '' : pathname}`

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={description} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={description} />
            <meta property='og:type' content='website' />
            <meta property='og:site_name' content={siteConfig.name} />
            <meta property='og:url' content={pageUrl} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={description} />

            {ogImage && <meta property='og:image' content={ogImage} />}
            {ogImage && <meta property='og:image:width' content='1200' />}
            {ogImage && <meta property='og:image:height' content='630' />}
            {ogImage && <meta property='og:image:alt' content={`${siteConfig.name}. ${siteConfig.tagline}`} />}
            {ogImage && <meta name='twitter:image' content={ogImage} />}
        </Head>
    )
}
